import { defineStore } from "pinia";
import { ref, reactive } from "vue";
import { useClausulasConfirmacionStore } from ".";

export const useNotificacionStore = defineStore(
  "notificacion",
  () => {
    // State Properties
    const isInitizalized = ref(false);
    const currentComponentBody = ref("");
    const currentComponentValues = reactive({
      Solicitantes: false,
      Ubicacion: false,
      Documentos: false,
      Cotizacion: false,
      Pago: false,
      EnvioDomicilio: false,
      ComplementaNotificado: false,
      ComplementaSolicitantes: false,
      EntregaDocumentos: false,
      FirmaDocumentos: false,
      Diligencia: false,
      Actas: false,
      Expediente: false,
      Terminado: false,
      EsperaValidacion: false,
    });

    const currentComponentValuesMaps = {
      Solicitantes: "Solicitantes",
      Ubicacion: "Domicilio a notificar",
      Documentos: "Documentos a notificar",
      Cotizacion: "Cotización",
    };

    // Entity Properties
    const id = ref(0);
    const id_cotizaciones = ref(null);
    const id_estatus = ref(null);
    const estatus = ref(null);
    const corredurias_id = ref(null);
    const tipo_solicitante = ref(null);
    const fad = ref(false);
    const contenido_digital = ref(false);
    const acta_express = ref(false);
    const envio_domicilio = ref(false);
    const costo_zona = ref(0);
    const costo_total = ref(0);
    const referencia = ref(null);

    const solicitantes = ref([]);
    const documentos = ref([]);
    const clausulas_confirmacion = ref([]);

    const cotizacion = reactive({
      isCalculated: false,
      id: 0,
      cupones_id: 0,

      precio_total: 0,

      conceptos: {
        domicilio_notificacion: {
          zona: "",
          precio: 0,
        },
        documento_adicional: {
          cantidad: 0,
          precio: 0,
        },
        pagina_adicional: {
          cantidad: 0,
          precio: 0,
        },
        contenido_digital: {
          cantidad: 0,
          precio: 0,
        },
        fad: {
          cantidad: 0,
          precio: 0,
        },
        envio_domicilio: {
          cantidad: 0,
          precio: 0,
        },
        acta_express: {
          cantidad: 0,
          precio: 0,
        },
        cupon_info: {
          id: null,
          tipo: 0,
          descuento: 0,
          nombre: "",
        },
        costo_antes_extras_descuentos: 0,
        costo_con_extras: 0,
        costo_total: 0,
      },
      infoCupon: {
        id: null,
        tipo: null,
        descuento: null,
        nombre: null,
      },
    });
    const currentDomicilio = reactive({
      tieneExtranjero: false,
      tieneTipo: false,
      compareciente: false,
      extranjero: null,

      calle: null,
      num_exterior: null,
      num_interior: null,
      colonia: null,
      delegacion_municipio: null,
      ciudad: null,
      entidad: null,
      pais: "México",
      codigo_postal: null,
      lat: 19.432,
      lng: -99.132,
    });
    const notificado = reactive({
      id: 0,
      id_domicilios: 0,
    });

    // Actions
    function initNotificacionStore() {
      const clausulasConfirmacionStore = useClausulasConfirmacionStore();

      deleteStore();
      currentComponentBody.value = "Solicitantes";
      clausulasConfirmacionStore
        .fetchClausulasConfirmacionCatServicioId(2)
        .then((value) => (clausulas_confirmacion.value = value))
        .then(() => (isInitizalized.value = true));
    }

    function getClausulasConfirmacion() {
      if (currentComponentBody.value === "Ubicacion") {
        return clausulas_confirmacion.value.filter((c) => [1].includes(c.id));
      } else if (currentComponentBody.value === "Cotizacion") {
        const arr = [2, 4, 5, 6];
        const notificacion = useNotificacionStore();

        if (!notificacion.fad) {
          arr.push(3);
        }

        return clausulas_confirmacion.value.filter((c) => arr.includes(c.id));
      }
    }

    function setComponentBody(value) {
      currentComponentBody.value = value;
    }

    function resetStore() {
      // State Properties
      isInitizalized.value = false;
      currentComponentBody.value = "";
      Object.assign(currentComponentValues, {
        Solicitantes: false,
        Ubicacion: false,
        Documentos: false,
        Cotizacion: false,
        Pago: false,
        EnvioDomicilio: false,
        ComplementaNotificado: false,
        ComplementaSolicitantes: false,
        EntregaDocumentos: false,
        FirmaDocumentos: false,
        Diligencia: false,
        Actas: false,
        Expediente: false,
        Terminado: false,
        EsperaValidacion: false,
      });

      // Entity Properties
      id.value = 0;
      estatus.value = null;
      id_estatus.value = null;
      id_cotizaciones.value = null;
      corredurias_id.value = null;
      tipo_solicitante.value = null;
      fad.value = false;
      contenido_digital.value = false;
      acta_express.value = false;
      envio_domicilio.value = false;
      costo_zona.value = 0;
      costo_total.value = 0;
      referencia.value = null;

      solicitantes.value = [];
      documentos.value = [];
      clausulas_confirmacion.value = [];

      // Cotización
      Object.assign(cotizacion, {
        isCalculated: false,
        id: 0,
        cupones_id: 0,
        precio_total: 0,
        conceptos: {
          domicilio_notificacion: { zona: "", precio: 0 },
          documento_adicional: { cantidad: 0, precio: 0 },
          pagina_adicional: { cantidad: 0, precio: 0 },
          contenido_digital: { cantidad: 0, precio: 0 },
          fad: { cantidad: 0, precio: 0 },
          envio_domicilio: { cantidad: 0, precio: 0 },
          acta_express: { cantidad: 0, precio: 0 },
          cupon_info: { id: null, tipo: 0, descuento: 0, nombre: "" },
          costo_antes_extras_descuentos: 0,
          costo_con_extras: 0,
          costo_total: 0,
        },
        infoCupon: {
          id: null,
          tipo: null,
          descuento: null,
          nombre: null,
        },
      });

      // Domicilio
      Object.assign(currentDomicilio, {
        tieneExtranjero: false,
        tieneTipo: false,
        compareciente: false,
        extranjero: null,
        calle: null,
        num_exterior: null,
        num_interior: null,
        colonia: null,
        delegacion_municipio: null,
        ciudad: null,
        entidad: null,
        pais: "México",
        codigo_postal: null,
        lat: 19.432,
        lng: -99.132,
      });

      // Notificado
      Object.assign(notificado, {
        id: 0,
        id_domicilios: 0,
      });
    }

    function deleteStore() {
      resetStore();
      localStorage.removeItem("notificacion");
    }

    return {
      isInitizalized,
      currentComponentBody,
      currentComponentValues,
      currentComponentValuesMaps,

      id,
      estatus,
      id_cotizaciones,
      corredurias_id,
      solicitantes,
      tipo_solicitante,
      documentos,
      fad,
      contenido_digital,
      acta_express,
      envio_domicilio,
      costo_zona,
      costo_total,
      cotizacion,
      currentDomicilio,
      notificado,
      clausulas_confirmacion,

      initNotificacionStore,
      getClausulasConfirmacion,
      setComponentBody,
      resetStore,
      deleteStore,
    };
  },
  {
    persist: true,
  },
);
